import React from 'react';
import PropTypes from 'prop-types';
import { getCdnImage } from '../../../utils/ImageManager';
import getCdnSrcset from '../../../utils/srcSetHelper';
import styles from './Carousel-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';
import classNames from "classnames";

const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

function Media(props) {
  const {
    className,
    component: ComponentProp,
    image,
    src,
    srcset,
    altText,
    isNoWidth,
    productName
  } = props;
  const Component = ComponentProp || 'div';


  // Compose descriptive alt text if missing or empty
  let computedAltText = altText && altText.trim() !== ''
    ? altText
    : productName
      ? `Imagem do produto: ${productName}`
      : 'Imagem do produto';

  const isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  // Make banner images focusable, but exclude carousel images (which have rounded-10 class)
  const isBannerImage = Component === i18nMessages.bannerPicture && 
                        (!className || !className.includes('rounded-10'));
  const getImagePictureMedia = () => <picture>
    <source
      srcSet={isNoWidth ? srcset : getCdnSrcset(srcset, 1600, 768)}
      media="(min-width: 1024px)"
    />
    <img
      className={classNames(styles.carouselImg, className)}
      loading={"auto"}
      src={isNoWidth ? (image || src) : getCdnImage(image || src, { w: 767 })}
      alt={computedAltText}
      tabIndex={isBannerImage ? "0" : undefined}
      aria-label={isBannerImage ? computedAltText : undefined}
    />
  </picture>;
  if (Component == i18nMessages.img || Component == i18nMessages.picture) {
    return (
      <picture>
        <source
          srcSet={isNoWidth ? srcset : getCdnSrcset(srcset, 1600, 768)}
          media="(min-width: 768px)"
        />
        <img
          className={styles.carouselImg}
          src={isNoWidth ? image : getCdnImage(image, { w: 767 })}
          alt={computedAltText}
        />
      </picture>
    );
  }
  if (Component === i18nMessages.bannerPicture) {
    return getImagePictureMedia();
  }
  return (
    <Component
      className={className}
      src={isMediaComponent ? image || src : undefined}
      srcSet={srcset}
      alt={computedAltText}
    />
  );
}

Media.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: PropTypes.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: PropTypes.string,
  srcset: PropTypes.string,
  altText: PropTypes.string.isRequired,
  /**
   * @ignore
   */
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Media = ({prop = val, component = 'div', src = '', srcset = '', image = '', className = '' }) =>

export default Media;
